import React from 'react';
import { IMPACT_COLORS, PROBABILITY_LABELS } from '../../utils/constants';
import Badge from '../shared/Badge';

function OpenRisksList({ risks = [], onEntryClick }) {
  if (!risks.length) return <div className="list-empty">Sin riesgos críticos abiertos</div>;
  return (
    <div className="item-list">
      {risks.map(r => (
        <div
          key={r.id}
          className="item-row clickable"
          onClick={() => r.entry_id && onEntryClick?.(r.entry_id)}
          style={{ cursor: r.entry_id ? 'pointer' : 'default' }}
        >
          <span className="priority-dot" style={{ background: IMPACT_COLORS[r.impact] }} />
          <div className="item-row__main">
            <span className="item-row__title">
              {r.description?.slice(0, 80)}{r.description?.length > 80 ? '…' : ''}
            </span>
            <div className="item-row__meta">
              <Badge label={PROBABILITY_LABELS[r.probability] || r.probability} color={IMPACT_COLORS[r.impact]} />
              {r.task_title && <span className="meta-chip">→ {r.task_title}</span>}
              {r.entry_id && <span className="meta-chip" style={{ color: 'var(--accent)' }}>Ver predicado →</span>}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default OpenRisksList;
